<template>
  <section class="passwords">
    <span> {{ $t("password.report_new_password") }} </span>

    <Notification
      :resource="notification"
      v-show="checkPasswordsLenth && !checkPasswords"
    />

    <v-form
      @submit.prevent="changePassword"
      v-model="formValidation"
      lazy-validation
      ref="form"
      class="mt-4"
    >
      <v-text-field
        v-model="newPassword"
        :label="$t('inputs.new_password')"
        class="border__radius-10"
        :rules="[rules.requerid, lengthRule.min, lengthRule.max]"
        :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showNewPass ? 'text' : 'password'"
        @click:append="showNewPass = !showNewPass"
        outlined
        dense
      ></v-text-field>

      <v-text-field
        v-model="confirmPassword"
        :label="$t('inputs.confirm_new_passoword')"
        class="border__radius-10"
        :rules="[rules.requerid, lengthRule.min, lengthRule.max]"
        :append-icon="showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showConfirmPass ? 'text' : 'password'"
        @click:append="showConfirmPass = !showConfirmPass"
        outlined
        dense
      ></v-text-field>
    </v-form>

    <v-btn
      class="border__radius-10 btn__default btn"
      color="primary"
      type="submit"
      height="40"
      depressed
      :disabled="isLoading || !checkPasswords"
      :loading="isLoading"
      block
      @click="changePassword"
    >
      {{ $t("buttons.continue") }}
      <v-icon class="icon" size="18">mdi-arrow-right</v-icon>
    </v-btn>
  </section>
</template>

<script>
import Notification from "@/components/widgets/notifications/Notification.vue";
import formRules from "@/mixins/formRules";
import { mapGetters, mapActions } from "vuex";
import { setNewPassword } from "@/services/password";

export default {
  name: "PasswordsComponent",

  data: () => ({
    newPassword: "",
    confirmPassword: "",

    lengthRule: {
      min: (v) => v.length > 5 || "Mínimo de 6 caracteres",
      max: (v) => v.length < 23 || "Máximo de 23 caracteres",
    },

    showNewPass: false,
    showConfirmPass: false,
    isLoading: false,
  }),

  computed: {
    ...mapGetters({
      storeResource: "getPasswordDetails",
    }),

    checkPasswordsLenth() {
      return this.newPassword.length >= 6 && this.confirmPassword.length >= 6;
    },

    checkPasswords() {
      if (this.checkPasswordsLenth) {
        return this.newPassword === this.confirmPassword;
      }

      return false;
    },

    notification() {
      return {
        type: "warning",
        icon: "mdi-alert-circle-outline",
        title: this.$t("password.error_password"),
        message: this.$t("password.check_password_inputs"),
      };
    },
  },

  mixins: [formRules],

  components: { Notification },

  methods: {
    ...mapActions(["changePasswordStep"]),

    async changePassword() {
      this.isLoading = true;

      if (this.$refs.form.validate() && this.checkPasswords) {
        const data = {
          email: this.storeResource.email,
          token: this.storeResource.token,
          password: this.newPassword,
          password_confirmation: this.confirmPassword,
        };

        const { response, status } = await setNewPassword(data);

        if (status) {
          this.changePasswordStep("Finish");
        } else {
          this.$snackbar.setParams(
            "error",
            this.$t("messages.error_not_defined"),
            response.message
          );
        }
      } else if (!this.checkPasswords) {
        this.$snackbar.setParams(
          "error",
          this.$t("messages.error_not_defined"),
          this.$t("messages.error_password_not_match")
        );
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.passwords {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 15px;

  .btn {
    margin-top: -10px;
  }

  .icon {
    position: absolute;
    right: 0px;
  }
}
</style>
